module.exports = __webpack_public_path__ + "static/media/choithramsRssFeed.4c2b82e1.png";